import * as _ from "lodash";
import ReactDOM from "react-dom";
import React, { useEffect, useState } from "react";

import { viewerOptions, viewerState } from "../../viewer";
import { ViewerUtils } from "../../common/viewerUtils";

interface WebProps {
    viewer: Autodesk.Viewing.GuiViewer3D,
    setTitle: (title: string) => void;
}

const getData = async (selection, viewer) => {
    
    if (viewerOptions.webData == null) {
        return null;
    }

    const selectedId = selection.length === 1 ? _.head(selection) as number : null;

    if (selectedId != null) {
        const guid = viewerOptions.idMap.guid(viewerOptions.guid, selectedId);
        
        const wd = viewerOptions.webData[guid];
        if (wd == null) {
            const parent = await ViewerUtils.getNodeParent(selectedId, viewer);
            if (parent != null) {
                return await getData([parent], viewer);
            } else {
                return null;
            }
        }
        return wd;
    } else {
        return null;
    }
}

const WebContainer: React.SFC<WebProps> = (props) => {
    const [data, setData] = useState(null);
    useEffect(() => {
        const onSelectionChange = async (evt) => {
            const newData = await getData(evt.nodeArray, props.viewer);
            setData(newData);
            props.setTitle(newData != null ? newData["Title"] : null);
        }

        const getInitial = async () => {
            const initial = await getData(props.viewer.getSelection(), props.viewer);
            setData(initial);
        }
        getInitial();

        props.viewer.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, onSelectionChange);
        return () => {
            props.viewer.removeEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, onSelectionChange);
        };
    });

    if (data != null) {
        return <iframe className="web-frame" src={data["Url"]} allow="encrypted-media"></iframe>;
    } else {
        return <div className="centered-view">Select single element to view data.</div>;
    }
}


export class WebPanel extends Autodesk.Viewing.UI.DockingPanel {

    private viewer: Autodesk.Viewing.GuiViewer3D;

    private contentDiv: HTMLDivElement;
    private reactNode;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        super(viewer.container as HTMLElement, "SmartDrawings-Panel-Web", "No selection", null);
        this.viewer = viewer;

        this.container.classList.add("web-panel");

        this.contentDiv = document.createElement("div");
        this.contentDiv.classList.add("content");
        this.container.appendChild(this.contentDiv);
    }

    async setVisible(show: boolean) {
        super.setVisible(show);
        if (show) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = ReactDOM.render(<WebContainer viewer={this.viewer}
                setTitle={title => this.setTitle(title || "No selection", null)} />, this.contentDiv);
        } else if (this.reactNode) {
            ReactDOM.unmountComponentAtNode(this.contentDiv);
            this.reactNode = null;
        }
    }

}